import Vue from 'vue';

import ObiApp from '@/components/Common/ObiApp';
import ObiLoading from '@/components/Common/ObiLoading';
import ObiText from '@/components/UI/ObiText';
import ObiInput from '@/components/UI/ObiInput';
import ObiForm from '@/components/UI/ObiForm';
import ObiFloatingInput from '@/components/UI/ObiFloatingInput';
import ObiButton from '@/components/UI/ObiButton';
import ObiIcon from '@/components/UI/ObiIcon';
import ObiSelect from '@/components/UI/ObiSelect';
import ObiImage from '@/components/UI/ObiImage';
import ObiCol from '@/components/UI/ObiCol';
import ObiRow from '@/components/UI/ObiRow';
import ObiAlert from '@/components/UI/ObiAlert';
import ObiCard from '@/components/UI/ObiCard';
import ObiTitle from '@/components/UI/ObiTitle';
import Obi404 from '@/components/UI/Obi404';
import DeviceOnlineIcon from '@/components/Icons/general/DeviceOnlineIcon';

Vue.component('ObiApp', ObiApp);
Vue.component('ObiLoading', ObiLoading);
Vue.component('ObiText', ObiText);
Vue.component('ObiInput', ObiInput);
Vue.component('ObiForm', ObiForm);
Vue.component('ObiFloatingInput', ObiFloatingInput);
Vue.component('ObiButton', ObiButton);
Vue.component('ObiIcon', ObiIcon);
Vue.component('ObiSelect', ObiSelect);
Vue.component('ObiImage', ObiImage);
Vue.component('ObiCol', ObiCol);
Vue.component('ObiRow', ObiRow);
Vue.component('ObiAlert', ObiAlert);
Vue.component('ObiCard', ObiCard);
Vue.component('ObiTitle', ObiTitle);

Vue.component('Obi404', Obi404);
Vue.component('DeviceOnlineIcon', DeviceOnlineIcon);

Vue.component('ObiPhoneInput', () => import('@/components/UI/ObiPhoneInput'));
Vue.component('ObiSurveySteps', () => import('@/components/UI/ObiSurveySteps'));
Vue.component('ObiStepItem', () => import('@/components/UI/ObiStepItem'));
Vue.component('ObiSurveyAnswers', () => import('@/components/UI/ObiSurveyAnswers'));
